const alphalinkClientAccount = {
  alphalinkId: {
    label: "Id Alphalink",
  },
  alphalinkAccountCreation: {
    label: "Création du compte",
    flashbagMessage: "La création du compte chez Alphalink a réussi",
    flashbagMessageFailure: "La création du compte chez Alphalink a raté"
  }
};

export default alphalinkClientAccount;
